import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { GuideModal } from './GuideModal';
import { Sparkle } from './Sparkle';
export function Hero() {
  const [guideOpen, setGuideOpen] = useState(false);

  // Auf Desktop bleibt die Einblend-Animation erhalten; auf Handys erscheinen
  // Überschrift und Bild sofort, damit der Ladewert (LCP) nicht verzögert wird.
  const [animate] = useState(() => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches);
  const fadeUp = (y: number, delay = 0) => animate ? {
    initial: {
      opacity: 0,
      y
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.5,
      delay,
      ease: 'easeOut' as const
    }
  } : {};
  return <section id="start" className="relative w-full px-4 pb-0 pt-10 sm:px-6 sm:pt-12" data-id="element-293" data-mp="3d1sakxd0hjt4">
      <div className="mx-auto grid max-w-[1300px] items-end gap-8 lg:grid-cols-[2.6fr_1fr] lg:gap-2 xl:grid-cols-[1.75fr_1fr] xl:gap-4" data-id="element-294" data-mp="381xkgw128y94">
        <div className="flex h-full flex-col justify-center pb-0 pt-2 text-center sm:pt-2 lg:pb-16 lg:pt-0 lg:pl-0 xl:pl-12 xl:text-left" data-id="element-295" data-mp="3j9265qny7uwl">
          <div className="relative block w-full self-center lg:w-[136%] lg:self-start xl:w-full" data-id="element-296" data-mp="39acw2k2aneqw">
            <Sparkle className="animate-sparkle left-3 -top-5 h-5 w-5 sm:-left-2 sm:-top-3 sm:h-6 sm:w-6 md:hidden lg:block lg:-left-6 lg:-top-6 lg:h-8 lg:w-8" data-id="element-297" data-mp="3e9fq79gqk0k3" />
            <Sparkle className="animate-sparkle-delayed -bottom-1 -right-1 h-4 w-4 sm:-bottom-2 sm:-right-4 sm:h-5 sm:w-5 md:bottom-1 md:left-[39%] md:right-auto lg:-bottom-3 lg:left-auto lg:-right-7" data-id="element-298" data-mp="30ggg5mzq2yjx" />
            <motion.h1 {...fadeUp(16)} className="font-display text-gold-3d mt-0 text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl md:text-justify lg:text-4xl lg:text-justify xl:text-justify" data-id="element-299" data-mp="2qlofuber9xlg">
              Verdiene 10.000€+ monatlich als Closerin, selbst wenn du noch nie verkauft hast –
              ohne Social Media Reichweite &amp; ohne eigenes Produkt
            </motion.h1>
          </div>

          <p className="mx-auto mt-5 max-w-full text-[15px] leading-relaxed text-white sm:text-base lg:mx-0 lg:pr-10 lg:text-left" data-id="element-300" data-mp="nat8vfsf4smt">
            <span className="block font-semibold uppercase tracking-wide" data-id="element-301" data-mp="id048r6rk6on">
              Raus aus dem 9-to-5-Hamsterrad.
            </span>
            <span className="mt-3 block" data-id="element-302" data-mp="dbastafmpr01">
              In nur 8 Wochen zeigen wir dir, wie du als Premium-Closerin ortsunabhängig arbeiten
              und dir mit deinen Sales-Skills ein attraktives Einkommen aufbauen kannst.
            </span>
            <span className="mt-3 block" data-id="element-303" data-mp="111omf5dv3xwq">
              Lerne, authentisch und ohne Druck zu verkaufen, hochpreisige Angebote sicher
              abzuschließen und dabei 500–1.500€ Provision pro Abschluss zu verdienen – auch ohne
              Vorkenntnisse.
            </span>
          </p>

          <div className="relative mx-auto mt-8 self-center lg:mx-0 lg:translate-y-4 lg:self-start xl:translate-y-0" data-id="element-304" data-mp="3hqaj2p91pbl1">
            <Sparkle className="animate-sparkle-fast -bottom-3 -right-4 h-6 w-6" data-id="element-305" data-mp="1xavz0ob4wg9d" />
            <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-306" data-mp="21bxy9551wsbc">
              Guide kostenlos sichern
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-307" data-mp="2g02jafrktfxa" />
            </button>
          </div>
        </div>

        <div className="relative flex items-end justify-center self-end lg:justify-end" data-id="element-308" data-mp="2ky42r1swzh9a">
          <motion.img {...fadeUp(30, 0.15)} src="https://cdn.magicpatterns.com/uploads/nFNmmy8cS1ztQEVWsSgFT1/image.png" alt="Tina Xla mit Laptop und Hot Sales Girls Logo" fetchPriority="high" decoding="async" className="block w-[110%] max-w-3xl object-contain md:w-full md:max-w-2xl lg:w-[152%] lg:max-w-4xl xl:w-[115%] xl:max-w-5xl" data-id="element-309" data-mp="2ozz60bueo4pp" />

          <ul className="pointer-events-none absolute inset-0" data-id="element-310" data-mp="4acj13lsp937">
            <motion.li initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.35,
            ease: 'easeOut'
          }} className="absolute left-[3%] top-[46%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:left-[1%] sm:text-xs md:left-[22%] lg:-left-[47%] lg:top-[42%] xl:left-[3%] xl:top-[52%]" data-id="element-311" data-mp="3vhxgzllx9bzl">
              ✓ 100% Ortsunabhängig
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: 16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.45,
            ease: 'easeOut'
          }} className="absolute right-[7%] top-[62%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:right-[21%] sm:text-xs md:right-[26%] lg:right-[9%] lg:top-[58%] xl:right-[25%] xl:top-[64%]" data-id="element-312" data-mp="3ri6jz05sxzmm">
              ✓ Freie Zeiteinteilung
            </motion.li>
            <motion.li initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.55,
            ease: 'easeOut'
          }} className="absolute bottom-[10%] left-[2%] rounded-full border border-hot-600 bg-hot-600/15 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 backdrop-blur-sm sm:left-[5%] sm:text-xs md:left-[20%] lg:-left-[47%] lg:bottom-[12%] xl:left-[1%] xl:bottom-[14%]" data-id="element-313" data-mp="zlslnn4qcyng">
              ✓ Ohne Vorkenntnisse
            </motion.li>
          </ul>
        </div>
      </div>

      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-314" data-mp="7rqmff1fe685" />
    </section>;
}